module.exports = __webpack_public_path__ + "fdfac2b0ae0a19db56dbaf962e9b8e51.png";